module.exports = __webpack_public_path__ + "media/images/gifts/open_end/sug_aberto_5-cd14bc474c816c5ca48e8f6a47b4e335.jpg";